import useScript from 'utils/hooks/use-script';

type HubspotCalendarProps = {
    url: string
}

const HubspotCalendar = ({ url }:HubspotCalendarProps) => {
  useScript('https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js', { removeOnUnmount: true });
  return <div className="meetings-iframe-container" data-src={ `${url}?embed=true` }></div>;
};

export default HubspotCalendar;
